export default __webpack_public_path__ + "static/media/Experince.271daf94.PNG";